<template>
  <div class="disease-question-container">
    <hr />
    <div class="button-container">
      <div class="title">
        {{ $store.state.labels.diseaseHistory[this.diseaseCode] }}
      </div>
      <div class="button-container__inner">
        <button-component
          methods="toggleActive"
          buttonLabel="YES"
          class="button"
          @toggleActive="toggleActive"
          :index="0"
          :class="{
            active: isActive && isDefault == false
          }"
          :data-test="`${diseaseCode}-yes`"
        />
        <button-component
          methods="toggleActive"
          buttonLabel="NO"
          class="button"
          @toggleActive="toggleActive"
          :index="1"
          :class="{
            active: !isActive && isDefault == false
          }"
          :data-test="`${diseaseCode}-no`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonComponent from "../../atoms/Button";
import VueTypes from "vue-types";
import { truncate } from "fs";

export default {
  data() {
    return {
      isDefault: true
    };
  },
  props: {
    diseaseCode: VueTypes.string.isRequired,
    useIn: VueTypes.string.isRequired
  },
  components: {
    ButtonComponent
  },
  computed: {
    isActive() {
      if (
        this.$store.state.aiPrediction.karteData.features[0][this.useIn][
          this.diseaseCode
        ]
      ) {
        return true;
      }
      return false;
    }
    // ボタン初期状態に関するプロパティを使用する
    // デフォルト状態がONの場合、どちらも未入力の状態にする
    // クリックで、OFFに変更される（以降ONになる事はない）
    // 外部から、それぞれのDefault状態を取得できるようにする
    // Default状態が一つでもON出会った場合、先に進めないようにする
  },
  methods: {
    toggleActive(index) {
      // 初期状態から解除するための処理
      if (this.isDefault) {
        this.isDefault = false;

        // 病歴項目にチェックしたことを親コンポーネントに伝える
        this.$emit("isChecked");
      }

      let bool = false;
      if (index === 0) {
        bool = true;
      }
      this.$emit("toggleDisease", this.diseaseCode, bool);
    }
  }
};
</script>

<style scoped>
.title {
  text-align: left;
  line-height: 50px;
  font-family: "HiraKakuPro-W6";
}
/* YesNoボタン調整用 */
.button-container {
  display: flex;
  justify-content: space-between;
  vertical-align: center;
}
.button-container__inner {
  display: flex;
}
.button {
  color: #d8d8d8;
  font-family: "HiraKakuPro-W6";
  font-size: 20px;
  padding: 4px;
  width: 80px;
  height: 40px;
  margin: 5px;
}
.active {
  background-color: #c5d7ef !important;
  color: #ffffff;
}
</style>
